<template>
  <div>
    <div>
      <!-- list:{{list}} -->
      <div style="padding: 0.5rem" v-for="ls in list" :key="ls.ItemName">
        <van-row v-if="ls.Qty > 0">
          <van-col span="2" align="center">
            <span style="font-weight: bold">{{ ls.Qty }}</span>
          </van-col>

          <van-col span="14">
            <!-- {{ls}} -->
            <div style="color: black">{{ ls.ItemName }}</div>
            <span v-for="nt in ls.Notes" :key="nt.ItemNote">
              <van-tag plain type="primary" v-if="nt.value">{{ nt.ItemNote }}</van-tag>
            </span>
            <div style="color: orangered">${{ getItemSum(ls) }}</div>

            <div v-for="s2 in ls.S2" :key="s2.lv">
              <div v-for="it in s2.items" :key="it.ItemName">
                <div v-if="it.value">
                  {{ it.ItemName }}
                  <span v-if="Number(it.Price) > 0"> ${{ Number(it.Price) }}</span>
                  <span v-if="Number(it.value) > 1"> X{{ Number(it.value) }}</span>
                  <div>
                    <span v-for="nt in it.Notes" :key="nt.ItemNote">
                      <van-tag plain type="primary" v-if="nt.value">
                        {{ nt.ItemNote }}
                      </van-tag>
                    </span>
                  </div>
                  <div v-if="it.ItemType == 'SS'">
                    <!-- {{it.S2}}   -->
                    <div v-for="level in it.S2" :key="level.lv">
                      <!-- {{level}} -->
                      <div v-for="si in level.items" :key="si.ItemName">
                        <div v-if="si.value" style="padding-left: 1rem">
                          {{ si.ItemName }}
                          <span v-if="Number(si.Price) > 0">
                            ${{ Number(si.Price) }}</span
                          >
                          <span v-if="Number(si.value) > 1">
                            X{{ Number(si.value) }}</span
                          >
                          <div>
                            <span v-for="nt in si.Notes" :key="nt.ItemNote">
                              <van-tag plain type="primary" v-if="nt.value">
                                {{ nt.ItemNote }}
                              </van-tag>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-col>

          <van-col span="8" align="right">
            <el-button
              type="text"
              icon="el-icon-remove-outline"
              style="padding: 0px"
              circle
              @click="subQty(ls)"
            ></el-button>

            <el-button
              type="text"
              icon="el-icon-circle-plus-outline"
              style="padding: 0px"
              circle
              @click="addQty(ls)"
            ></el-button>
          </van-col>
        </van-row>
        <!-- {{ls.S2}} -->
        <!-- <van-row>
          <van-col span="22" offset="2">
            <div v-for="s2 in ls.S2" :key="s2.lv">
              <div v-for="it in s2.items" :key="it.ItemName">
                <div v-if="it.value">  
                {{it.ItemName}} +${{Price}}
                </div>
              </div>
            </div>
          </van-col>
        </van-row>
        <van-row> -->
      </div>

      <van-divider />
      <div style="padding: 0 1rem 1rem 1rem">
        <van-row>
          <van-col span="12">
            <div>小計</div>
            <div v-if="params.DiscountRate > 0">
              折扣({{ params.DiscountRate / 10 }}折)
            </div>
            <div>運費</div>
            <div>合計</div>
          </van-col>
          <van-col span="12" align="right">
            <div>${{ getTotalSum() }}</div>
            <div v-if="Number(params.DiscountRate) > 0">$-{{ getDiscountAmt() }}</div>
            <div>${{ orderer.shipamt }}</div>
            <div style="color: orangered">${{ getCheckSum() }}</div>
          </van-col>
        </van-row>
      </div>

      <div v-if="!params.NoTableWare">
        <div class="line"></div>
        <van-cell center>
          <template #title>
            <span style="font-size: 1rem">索取一次性餐具用品</span>
          </template>
          <template #right-icon>
            <van-switch v-model="orderer.tableware" size="24" />
          </template>
          <template #label>
            <span v-if="!orderer.tableware">感謝您對永續環保盡一份心力!</span>
            <span v-if="orderer.tableware">附免洗餐具</span>
          </template>
        </van-cell>
      </div>

      <van-field v-model="orderer.remark" placeholder="新增備註(20字內)" maxlength="20" />
      <van-field v-model="orderer.carrier" placeholder="載具號碼(8個字,以/為首)" maxlength="8" />
      <van-field v-model="orderer.bno" placeholder="客戶統編" maxlength="8" />

      <div class="line"></div>
      <div style="padding: 1rem">
        <!-- {{orderer}} -->
        <div style="font-weight: bold">訂購資訊</div>
        <div v-if="orderer.potype == 0">
          <div>外帶自取</div>
          <div>
            取餐時間:
            <span>{{ orderer.date }} {{ orderer.time }}</span>
            <span v-if="orderer.time == ''">現在</span>
          </div>
          <div>
            {{ orderer.name }}
            <span v-if="orderer.tel != ''"> ({{ orderer.tel }})</span>
          </div>
        </div>
        <div v-if="orderer.potype == 1">
          <div>外送</div>
          <div>
            送達時間:
            <span>{{ orderer.time }}</span>
            <span v-if="orderer.time == ''">現在</span>
          </div>
          <div>
            {{ orderer.name }}
            <span v-if="orderer.tel != ''"> ({{ orderer.tel }})</span>
          </div>
          <div>
            地址:<span>{{ orderer.address }}</span>
          </div>
        </div>
      </div>

      <div class="line"></div>
      <div style="padding: 1rem">
        <!-- <div><van-icon name="balance-pay" size="1.2rem" />付款方式</div> -->
        <div style="font-weight: bold">付款方式</div>
        <van-radio-group v-model="orderer.paytype">
          <van-radio name="1" v-if="!params.DisableCash">取餐付款</van-radio>
          <van-radio name="2" v-if="params.LinePay">LINE PAY</van-radio>
          <van-radio name="3" v-if="params.CreditPay">信用卡付款</van-radio>
        </van-radio-group>
      </div>
      <div style="height: 10rem"></div>
    </div>

  </div>
</template>

<style scoped>
.qty {
  font-size: 2em;
}
.el-button {
  font-size: 2rem;
}
.van-tag {
  margin: 0 0 0 0.2rem;
}
.van-row {
  margin: 0 0 0.2rem 0;
}
.line {
  height: 0.5rem;
  color: #444;
  background-color: #eee;
}
.van-radio {
  font-size: 1rem;
  height: 3rem;
}
</style>

<script>
import list from "./json/list.json";
export default {
  name: "Car",
  props: {
    msg: String,
    list: Object,
    orderer: Object,
    params: Object,
  },
  data() {
    return {
      // list:[],
      amt: 0,
      // shipamt: 60,
      sumamt: 0,
      paytype: "",
      discountAmt: 0,
    };
  },
  methods: {
    init() {
      var app = this;
      app.$http
        .get("./list")
        .then((response) => {
          app.list = response.data;
          app.sum();
        })
        .catch(function (error) {
          console.log(error);
          app.list = list;
        });
    },
    addQty(obj) {
      obj.Qty++;
      if (obj.Qty >= 999) {
        obj.Qty = 999;
      }
    },
    subQty(obj) {
      obj.Qty--;
      if (obj.Qty <= 0) {
        obj.Qty = 0;
      }
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].Qty == 0) {
          this.list.splice(i, 1);
          break;
        }
      }
    },
    getItemSum(obj) {
      let amt = Number(obj.Price1);
      var notes = obj.Notes;
      if (notes != undefined) {
        for (let i = 0; i < notes.length; i++) {
          if (notes[i].value) {
            if (Number(notes[i].Remark > 0)) {
              amt += Number(notes[i].Remark);
            }
          }
        }
      }

      let s2 = obj.S2;
      for (let i = 0; i < s2.length; i++) {
        let items = s2[i].items;
        for (let j = 0; j < items.length; j++) {
          let item = items[j];
          // alert(item);
          if (item.value) {
            let qty = Number(items[j].value);
            amt += Number(item.Price) * qty;
            if (items[j].ItemType == "SS") {
              var s3 = items[j].S2;
              for (let k = 0; k < s3.length; k++) {
                var s3items = s3[k].items;
                for (let l = 0; l < s3items.length; l++) {
                  if (s3items[l].value) {
                    let s3qty = Number(s3items[l].value);
                    amt += Number(s3items[l].Price) * s3qty;
                  }
                }
              }
            }
          }
        }
      }
      amt *= obj.Qty;
      return amt;
    },
    getTotalSum() {
      let list = this.list;
      let amt = 0;
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        let ls = list[i];
        amt = this.getItemSum(ls);
        sum += amt;
      }

      // if (sum > 0) {
      //   if (this.params.DiscountRate > 0) {
      //     var rate = (100 - this.params.DiscountRate) * 0.01;
      //     var discountAmt = sum * rate;
      //     discountAmt = parseInt(discountAmt);
      //     if (discountAmt > sum) {
      //       discountAmt = sum;
      //     }
      //     this.discountAmt = discountAmt;
      //   }
      // }

      // this.orderer.poamt = sum + Number(this.orderer.shipamt);
      return sum;
    },

    getDiscountAmt() {
      if (this.params.DiscountRate <= 0 || this.params.DiscountRate == undefined) {
        return 0;
      }
      var rate = (100 - this.params.DiscountRate) * 0.01;
      var sum = this.getTotalSum();
      if (sum <= 0) {
        return 0;
      }
      var discountAmt = sum * rate;
      discountAmt = parseInt(discountAmt);
      if (discountAmt > sum) {
        discountAmt = sum;
      }
      return discountAmt;
    },
    getCheckSum() {
      var amt = 0;
      amt += this.getTotalSum();
      amt -= this.getDiscountAmt();
      amt += this.orderer.shipamt;
      return amt;
    },
  },
};
</script>
